import { get } from 'lodash';
import { Categories, Markets, Odds, Picks } from '../../../types/BetMarkets';
import { Match } from '../../../types/Matches';
import { bookies } from './bookies';

const getSpecificData = (data: any) => {
  let result = ' ';
  if (data.hasOwnProperty('number')) {
    result += data.number;
  } else if (data.hasOwnProperty('win')) {
    result += data.win;
  } else if (data.hasOwnProperty('home_player')) {
    result += `${data.home_player} - ${data.away_player}`;
  }
  return result;
};

export const transformToMarkets = (matches: Match[]) => {
  return matches.reduce((markets: Markets, jsonObject: Match) => {
    const marketType = `${jsonObject.market_type}`;
    const marketCode = `${jsonObject.market_code}`;
    const categoriesPath = `${marketType}.categories`;
    const scope = '-';
    const bookieName = get(bookies, [jsonObject.bookie_id, 'name']);
    const pickPath = `${marketType}.categories.${scope}.picks`;
    const oddsPath = `${marketType}.categories.${scope}.picks.${jsonObject.pick
      .split(' ')
      .join('_')}.odds`;
    const currentPicks = get(markets, pickPath, {}) as Picks;
    const currentOdds = get(markets, oddsPath, {}) as Odds;
    // There's a fucking SILENT error that happens when trying to access to
    // some undefined paths, so we use `get` to go around that.
    // The problem with this is that using get you can't mutate the object, so
    // we only use it as a reference to check if we can safely acces directly
    // to the neste property
    // This is ductaped as fuck, DON'T TOUCH IT WITHOUT KNOWING EXACTLY
    // WHAT YOU ARE DOING
    const currentOddsTmp = get(
      markets,
      [marketType, 'categories', '-', 'picks', jsonObject.pick, 'odds'],
      false,
    );
    const currentCategories = get(markets, categoriesPath, {}) as Categories;

    if (currentOddsTmp === false) {
      currentOdds[bookieName] = {
        id: jsonObject.id,
        bookie: bookieName,
        bookie_id: jsonObject.bookie_id,
        deeplink: jsonObject.deep_link,
        odds: jsonObject.bet_data,
      };
    } else {
      markets[marketType].categories[scope].picks[jsonObject.pick].odds[
        bookieName
      ] = {
        id: jsonObject.id,
        bookie: bookieName,
        bookie_id: jsonObject.bookie_id,
        deeplink: jsonObject.deep_link,
        odds: jsonObject.bet_data,
      };
    }

    currentPicks[`${jsonObject.pick}`] = {
      name: `${jsonObject.pick} ${getSpecificData(jsonObject.bet_data).trim()}`,
      odds: currentOddsTmp !== false ? currentOddsTmp : currentOdds,
    };
    currentCategories[scope] = {
      name: scope,
      picks: currentPicks,
    };
    markets[marketType] = {
      name: marketType.trim(),
      categories: currentCategories,
      code: marketCode,
    };
    return markets;
  }, {});
};
